import { atom } from "recoil";

export const radarJmaInfoState = atom({
  key: 'radarJmaInfoState',
  default: {}
});
